/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { useTranslation } from 'react-i18next'
import { Button, Icon, Message, MessageContent, MessageHeader, MessageItem, MessageList } from 'semantic-ui-react'
import { NavLink } from 'react-router-dom-v5-compat'
import { useQuery } from '@tanstack/react-query'
import useUser from '../Shared/UserProvider/useUser'
import { getPointOfSale } from '../../services/PointOfSale/PointOfSale.service'
import { isProviderAPos } from '../../services/Provider/Provider.service'
import useMediaQuery from 'beautiful-react-hooks/useMediaQuery'
import { MOBILE_THRESHOLD } from '../../constants'

const AcceptTermsOfUseMessage = () => {
    const [t] = useTranslation()
    const isMobile = useMediaQuery(`(max-width: ${MOBILE_THRESHOLD}px)`)
    const {user, can} = useUser()
    const canAccessBillingForm = can('STATIC', 'administration')

    const {data: pos} = useQuery({
        queryKey: ['pointofsales', user.getUserPos()?.id],
        queryFn: () => getPointOfSale(user.getUserPos()?.id),
        enabled: isProviderAPos(user.provider),
    })

    if (!pos || pos.hasAcceptedTermsOfUse) {
        return null
    }

    return (
      <div css={css`
          margin-bottom: 10px;
      `}>
          <Message
            icon
            attached
            color="orange"
            size="small"
          >
              <Icon name="signup"/>
              <MessageContent>
                  <MessageHeader>
                      {t('administration.billing.acceptTermsOfUse.terms_of_use_not_accepted')}
                  </MessageHeader>
                  <p>{t('administration.billing.acceptTermsOfUse.how_to_accept')}</p>
                  <MessageList>
                      <MessageItem>{t('administration.billing.acceptTermsOfUse.how_to_accept_step_1')}</MessageItem>
                      <MessageItem>{t('administration.billing.acceptTermsOfUse.how_to_accept_step_2')}</MessageItem>
                  </MessageList>
                  <p>{t('administration.billing.acceptTermsOfUse.how_to_accept_footer')}</p>
                  {!canAccessBillingForm && <p>{t('administration.billing.acceptTermsOfUse.ask_admin_to_accept')}</p>}
              </MessageContent>
          </Message>
          {canAccessBillingForm && (
            <Message
              attached="bottom"
              color="orange"
              size="small"
              fluid
              css={css`
                  &.ui.bottom.attached.message {
                      padding-top: 0;
                      padding-left: 1.5rem;
                      padding-right: 1.5rem;
                      box-shadow: -1px -1px 0 0 #f2711c inset,
                      1px -1px 0 0 #f2711c inset,
                      0 -1px 0 0 #f2711c inset;
                  }
              `}
            >
                <div css={css`
                    text-align: ${isMobile ? 'unset' : 'right'};
                `}
                >
                    <Button
                      size="tiny"
                      fluid={isMobile}
                      color="orange"
                      as={NavLink}
                      to="/settings/billing"
                    >
                        {t('administration.billing.acceptTermsOfUse.navigateToBillingFormButton')}
                    </Button>
                </div>
            </Message>
          )}
      </div>
    )
}

export { AcceptTermsOfUseMessage }
